import { FilterName, FilterState } from "../../../../state/AppState.ts";

export type ApiResponse = Partial<
  Omit<Record<FilterName, string[] | null>, "creation_date"> & {
    creation_date: {
      start_date: string | null;
      end_date: string | null;
    } | null;
  }
>;

export class FilterResponseMapper {
  apiToFrontend = (apiResponse: ApiResponse): FilterState => {
    const filters: FilterState = {};

    Object.entries(apiResponse || {}).forEach(([key, value]) => {
      if (value === null) return;

      if (this.isDateFilter(value)) {
        filters.creation_date = {};
        if (value.start_date) {
          const [startYear, startMonth] = value.start_date?.split("-") || [];
          filters.creation_date.start = {
            month: startMonth,
            year: startYear,
          };
        }
        if (value.end_date) {
          const [endYear, endMonth] = value.end_date?.split("-") || [];
          filters.creation_date.end = {
            month: endMonth,
            year: endYear,
          };
        }
      } else {
        filters[key as Exclude<FilterName, "creation_date">] =
          value as string[];
      }
    });

    return filters;
  };

  private isDateFilter = (
    value: unknown,
  ): value is { start_date: string; end_date: string } =>
    typeof value === "object" &&
    value !== null &&
    "start_date" in value &&
    "end_date" in value;
}
